import { Component, EventEmitter, Inject, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { NgForm } from '@angular/forms';
import { AppState } from '../../../store';
import { BaseForm, BaseFormInterface } from '../../../common/base/base-form.component';
import { NetsuiteConnection } from '../../connection.models';
import { NotifyService } from '../../../common/services/notify.service';
import { selectConnectionsErrors } from '../../store/connections.selectors';

@Component({
  selector: 'connection-form-netsuite',
  template: `
    <xp-form-validation type="NetSuiteConnection" [name]="formName">
      <form id="connectionFormNetsuite" name="connectionFormNetsuite" #form="ngForm" class="form">
        <div class="row">
          <div class="col-md-6">
            <xp-form-group>
              <label for="name">{{ 'connections.form.netsuite.labels.name' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="name"
                id="name"
                [(ngModel)]="connection.name"
                placeholder=""
              ></xp-input>
            </xp-form-group>
            <div class="form-group" *ngIf="connection.unique_id">
              <label for="unique_id">{{ 'connections.form.netsuite.labels.unique_id' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="unique_id"
                id="unique_id"
                [(ngModel)]="connection.unique_id"
                [attr.readonly]="true"
                [readOnly]="true"
              ></xp-input>
            </div>
            <connection-component-host-port [connection]="connection"></connection-component-host-port>
            <connection-component-username-password [connection]="connection"></connection-component-username-password>
          </div>
          <div class="col-md-6">
            <xp-form-group>
              <label for="database">{{ 'connections.form.netsuite.labels.database' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="database"
                id="database"
                [(ngModel)]="connection.database"
                placeholder=""
              ></xp-input>
            </xp-form-group>
            <xp-form-group>
              <label for="net_suite_account_id">{{ 'connections.form.netsuite.labels.account_id' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="net_suite_account_id"
                id="net_suite_account_id"
                [(ngModel)]="connection.net_suite_account_id"
                placeholder=""
              ></xp-input>
            </xp-form-group>
            <xp-form-group>
              <label for="role_id">{{ 'connections.form.netsuite.labels.role_id' | translate }}</label>
              <xp-input
                type="text"
                class="form-control"
                name="role_id"
                id="role_id"
                [(ngModel)]="connection.role_id"
                placeholder=""
              ></xp-input>
            </xp-form-group>
          </div>
        </div>
      </form>
    </xp-form-validation>
  `,
})
export class ConnectionFormNetsuiteComponent extends BaseForm implements BaseFormInterface {
  @Input() connection: Partial<NetsuiteConnection> = {};
  @Output() formValidationChange = new EventEmitter<boolean>();

  @ViewChild('form') form: NgForm;
  formName = 'connectionFormNetsuite';
  successMessageText = 'connection.form.success_message';
  errors$ = this.store.select(selectConnectionsErrors);
  errorTexts = [];

  constructor(
    protected store: Store<AppState>,
    protected notify: NotifyService,
    protected translate: TranslateService,
    @Inject('$rootScope') private $rootScope: any,
  ) {
    super();
  }
}
